import _ from 'lodash';

const ACTION_NAMESPACE = 'Campaign Promotions =>';

const sortDirections = {
  ASCENDING:  'asc',
  DESCENDING: 'desc',
};

sortDirections.ALL = _.values(sortDirections);

const campaignPromotionListSortBy = {
  CURRENT_FUTURE_PAST: 'currentFuturePast',
  PAST_CURRENT_FUTURE: 'pastCurrentFuture',
  DATE_CREATED:        'dateCreated',
  MANUAL:              'manual',
  RANDOM:              'random',
};

const sortFields = {
  DATE_CREATED: 'dateCreatedTimestamp',
  VALID_FROM:   'validFrom',
  VALID_TO:     'validTo',
  ID:           'id',
  SCORE:        'score',
};

const campaignPromotionSort = {
  ACTIVE_OPEN:  [sortFields.DATE_CREATED, sortFields.ID],
  ACTIVE:       [sortFields.VALID_FROM, sortFields.DATE_CREATED, sortFields.ID],
  FUTURE:       [sortFields.VALID_FROM, sortFields.DATE_CREATED, sortFields.ID],
  PAST:         [sortFields.VALID_TO, sortFields.DATE_CREATED, sortFields.ID],
  DATE_CREATED: [sortFields.DATE_CREATED],
  SCORE:        [sortFields.SCORE],
};

campaignPromotionSort.ALL = _.values(campaignPromotionSort);

const campaignPromotionListSortOptions = {
  CURRENT_FUTURE_PAST: { text: 'Current, future then past', value: campaignPromotionListSortBy.CURRENT_FUTURE_PAST },
  PAST_CURRENT_FUTURE: { text: 'Past, current then future', value: campaignPromotionListSortBy.PAST_CURRENT_FUTURE },
  DATE_CREATED:        { text: 'Newly created first', value: campaignPromotionListSortBy.DATE_CREATED },
  MANUAL:              { text: 'Manual Order', value: campaignPromotionListSortBy.MANUAL },
  RANDOM:              { text: 'Random', value: campaignPromotionListSortBy.RANDOM },
};

campaignPromotionListSortOptions.ALL = _.values(campaignPromotionListSortOptions);

campaignPromotionListSortOptions.NEXTGEN = _.values(_.omit(campaignPromotionListSortOptions, ['RANDOM', 'ALL']));

const PROMOTION_PANELS = {
  SETTINGS: 'settings',
  CONTENT:  'content',
};

const FORM_ID = 'campaign-promotions';

// Form field IDs used in Settings panel
export const FORM_FIELD_IDS = {
  NAME:             'name',
  DISPLAY_STRATEGY: 'displayStrategy',
  VALID_FROM:       'validFrom',
  VALID_TO:         'validTo',
  ORDER:            'score',
};

// Field IDs used in the Distribution panel and its subcomponents
export const SETTINGS_FORM_FIELDS = [
  FORM_FIELD_IDS.NAME,
  FORM_FIELD_IDS.ORDER,
  FORM_FIELD_IDS.DISPLAY_STRATEGY,
  FORM_FIELD_IDS.VALID_FROM,
  FORM_FIELD_IDS.VALID_TO,
];

const PROMOTION_ASSET_UPLOADER_PREFIX = 'campaign-promotions';
const PROMOTION_IMAGE_STATE_IDENTIFIERS = {
  MAIN_IMAGE:       `${PROMOTION_ASSET_UPLOADER_PREFIX}-main-image`,
  THUMBNAIL:        `${PROMOTION_ASSET_UPLOADER_PREFIX}-thumbnail`,
  BACKGROUND:       `${PROMOTION_ASSET_UPLOADER_PREFIX}-background`,
  LOCKED_THUMBNAIL: `${PROMOTION_ASSET_UPLOADER_PREFIX}-locked-thumbnail`,
};

const DTP_DATE_FORMAT = 'D MMM YYYY HH:mma';

const defaultLayoutJSON = {
  modules:    [],
  pageLayout: {
    sections: [{ type: 'form', rows: [{ columns: [{ modules: [] }], type: '1col_full' }] }],
  },
};

export {
  campaignPromotionListSortOptions,
  campaignPromotionListSortBy,
  campaignPromotionSort,
  sortFields,
  sortDirections,
  PROMOTION_PANELS,
  FORM_ID,
  DTP_DATE_FORMAT,
  PROMOTION_ASSET_UPLOADER_PREFIX,
  PROMOTION_IMAGE_STATE_IDENTIFIERS,
  defaultLayoutJSON,
  ACTION_NAMESPACE,
};
